module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_hokej-4774474da826ebfdcd56558f365a9dc9.mp4";